import { lazy } from 'react';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import AuthGuard from 'utils/route-guard/AuthGuard';
import CreativeEditLayout from 'layout/CreativeEditLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing
const CreativeEditPage = Loadable(lazy(() => import('views/creative-edit-page')));

// ==============================|| MAIN ROUTING ||============================== //

const CreativeEditRoutes = {
    path: '/',
    element: (
        <NavigationScroll>
            <AuthGuard>
                <CreativeEditLayout />
            </AuthGuard>
        </NavigationScroll>
    ),
    children: [
        {
            path: '/w/:workspaceId/p/:projectId/c/:campaignId/crt/:id',
            element: <CreativeEditPage />
        }
    ]
};

export default CreativeEditRoutes;
